import moment from "moment";

const formatDate = (date, dateFormat) => {
  const formattedDate = date.split(" ")[0];
  return moment(formattedDate).format(dateFormat);
};

export default formatDate;
